import React from 'react';

const AccessDenied = () => (
  <div>AccessDenied</div>
  );

export default AccessDenied;
